const isLoggedIn = state => state.isLoggedIn;
const customerId = state => state.customerId;
const access = state => state.access;
const refresh = state => state.refresh;
const userFirstAuth = state => state.userFirstAuth;

export default {
  isLoggedIn,
  access,
  refresh,
  customerId,
  userFirstAuth,
};
